import { uiblockerStyle } from '@bingads-webui-campaign-react/common-styles';

export const getStyles = (_, theme = { palette: {} }) => ({
  '@global': {
    ...uiblockerStyle(theme),
  },

  adsManager: {
    '& .ad-list-container': {
      margin: '32px 0',

      '& .ad-list-header': {
        fontWeight: 600,
        marginBottom: 16,
      },

      '& .ad-list-item': {
        background: '#FFFFFF',
        border: '1px solid #E1DFDD',
        borderRadius: '8px',
        boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
        width: '500px',
        minHeight: '150px',
        marginBottom: '16px',
        position: 'relative',

        '& .ad-preview-overlay': {
          display: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50%, rgba(0, 0, 0, 0.80) 100%)',
          borderRadius: '6px',
          padding: '16px',
          zIndex: 1,
          alignItems: 'flex-end',
          justifyContent: 'flex-end',

          '& button': {
            background: 'transparent',
            border: 'none',
            color: '#FFFFFF',
            marginLeft: '4px',
          },
        },

        '&:hover .ad-preview-overlay, &:focus-within .ad-preview-overlay': {
          display: 'flex',
        },

        '& .rsa-ad-preview-content-container, .dsa-ad-preview-content-container': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '20px',

          '& .ad-title-preview': {
            fontSize: '18px',
            lineHeight: '22px',
            color: '#1A0DAB',
          },
          '& .ad-url-preview': {
            fontSize: '14px',
            lineHeight: '20px',
            color: '#006621',
          },
          '& .ad-description-preview': {
            '& .ad-slug': {
              color: '#666',
              lineHeight: '24px',
              border: '1px solid #ddd',
              padding: '0 2px',
              fontSize: '11px',
              marginRight: '4px',
              borderRadius: '2px',
            },
            fontSize: '12px',
            lineHeight: '16px',
            color: '#666',
            marginTop: '4px',
          },
        },

        '& .mma-ad-preview-content-container': {
          position: 'relative',
          width: '100%',
          textDecoration: 'none',
          borderRadius: '8px',

          '&:active:hover': {
            textDecoration: 'none',
          },

          '& .ad-background': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',

            '& .ad-gradient-overlay': {
              position: 'absolute',
              width: '100%',
              height: '100%',
              borderRadius: '8px',
              backgroundImage: 'linear-gradient(to left, transparent 0, #333 100%)',
            },

            '& .ad-label': {
              color: '#767676',
              margin: '8px',
              padding: '0 2px',
              position: 'absolute',
              right: 0,
              top: 0,
              fontSize: '11px',
              lineHeight: '14px',
              borderRadius: '2px',
              backgroundColor: '#ddd',
            },

            '& .ad-preview-image': {
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'top',
              borderRadius: '8px',
            },
          },

          '& .mma-text-content-container': {
            position: 'relative',
            padding: '20px',
            color: '#FFF',
            wordWrap: 'break-word',

            '& .mma-short-headline': {
              fontSize: '18px',
              lineHeight: '22px',
            },

            '& .mma-display-url': {
              fontSize: '14px',
              lineHeight: '20px',
            },

            '& .mma-description': {
              fontSize: '12px',
              lineHeight: '16px',
            },

            '& .mma-callToAction': {
              color: '#515151',
              border: 'none',
              position: 'absolute',
              padding: '8px 16px',
              marginTop: '8px',
              fontSize: '12px',
              lineHeight: '16px',
              fontWeight: '600',
              borderRadius: '20px',
              backgroundColor: '#D3D3D3',
            },
          },
        },
      },
    },
  },
});
